// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__f3cO9","label":"CategoryService_label__-ku5t","location":"CategoryService_location__M0nNG"};